export default Object.freeze({
    Complete: 0,
    Partial: 1,
});
